import React from 'react';
import ko_KR from 'antd/es/locale/ko_KR';
import { ModalProvider } from 'contexts/ModalContext/ModalContext';
import { SideMenuProvider } from 'libs/contexts/SideMenuContext';
import { ConfigProvider } from 'antd';
import 'react-rater/lib/react-rater.css';
import 'moment/locale/ko';

export const CoreProvider: React.FC<{}> = ({ children }) => {
  const validateMessages = {
    required: '필수 항목입니다',
  };

  return (
    <ConfigProvider locale={ko_KR} form={{ validateMessages }} renderEmpty={(e) => <>없음</>}>
      <ModalProvider>
        <SideMenuProvider>{children}</SideMenuProvider>
      </ModalProvider>
    </ConfigProvider>
  );
};
